import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { SystemStyleObject } from '@mui/system/styleFunctionSx/styleFunctionSx';
import React from 'react';

import ExclamationSign from '@/assets/icons/exclamation-sign.svg?react';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  onClose(): void;
}

export const Forbidden: React.FC<Props> = (props: Props): React.ReactElement => {
  const { onClose } = props;
  const tr = useTranslator();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.content}>
        <Box sx={styles.iconContainer}>
          <ExclamationSign />
        </Box>
        <Typography variant="h4" sx={styles.title}>
          {tr('Access denied')}
        </Typography>
        <Typography variant="body1" sx={styles.message}>
          {tr("You don't have permission to access this section.")}
        </Typography>

        <Box mt={6} width="100%">
          <Button variant="dark" fullWidth={true} onClick={onClose}>
            {tr('CLOSE')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

const styles: Record<string, SystemStyleObject<Theme>> = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '400px',
    height: '100%',
    px: 8,
    zIndex: 4,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    width: '100%',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 80,
    height: 80,
    marginBottom: 3,
    color: 'error.main',
    '& svg': {
      width: '100%',
      height: '100%',
      fill: 'currentColor',
    },
  },
  title: {
    marginBottom: 2,
    fontWeight: 600,
    color: 'text.primary',
  },
  message: {
    color: 'text.secondary',
    lineHeight: 1.6,
  },
};
